import React from 'react';
import { useHistory } from 'react-router-dom';
import ErrorPage from '../../Components/ErrorPage/ErrorPage';

export const ActionNotAvailableErrorView = (): React.ReactElement<{}> => {
  const history = useHistory();

  return (
    <ErrorPage
      icon="Announcement"
      title="Sorry, this action is no longer available."
      onGoHome={() => history.replace('/app')}
    />
  );
};
